import axios from "axios";

export function keepAlive() {
  return axios.get("keepalive", {
    avoidLoadingFeature: true
  });
}
